import * as e from "react";
var o = globalThis != null && globalThis.document ? e.useLayoutEffect : () => {
};
export {
  o as useLayoutEffect
};
